import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../lib/api';
import { useBranding } from '../../contexts/BrandingContext';

interface VersionInfo {
  version: string;
  build_date: string;
  build_number: number;
  git_commit: string;
  release_notes: string;
  server_time: string;
}

const Footer: React.FC = () => {
  const [versionInfo, setVersionInfo] = useState<VersionInfo | null>(null);
  const [loading, setLoading] = useState(true);
  const { branding } = useBranding();

  useEffect(() => {
    const fetchVersionInfo = async () => {
      try {
        const response = await api.get('/core/version/');
        setVersionInfo(response.data);
      } catch (error) {
        console.error('Failed to fetch version info:', error);
        setVersionInfo({
          version: '1.0.0',
          build_date: new Date().toISOString(),
          build_number: 1,
          git_commit: 'unknown',
          release_notes: 'Version information unavailable',
          server_time: new Date().toISOString()
        });
      } finally {
        setLoading(false);
      }
    };

    fetchVersionInfo();
  }, []);

  if (loading) {
    return (
      <footer className="bg-gray-50 border-t border-gray-200 py-4 mt-auto">
        <div className="container mx-auto px-4">
          <div className="flex justify-center items-center">
            <div className="animate-pulse text-sm text-gray-500">
              Loading version info...
            </div>
          </div>
        </div>
      </footer>
    );
  }

  return (
    <footer className="bg-gray-50 border-t border-gray-200 py-4 mt-auto">
      <div className="container mx-auto px-4">
        <div className="relative flex justify-center items-center space-x-3 text-xs text-gray-500">
          <span className="text-sm text-gray-600">
            © {new Date().getFullYear()} {branding.copyrightSupplier || 'Arden Rede Ltd'}. All rights reserved.
          </span>
          <span>|</span>
          <Link
            to="/terms"
            className="hover:text-gray-700 transition-colors"
          >
            Terms & Conditions
          </Link>
          <span>|</span>
          <Link
            to="/privacy"
            className="hover:text-gray-700 transition-colors"
          >
            Privacy Policy
          </Link>
          {versionInfo && (
            <>
              <span>|</span>
              <span className="font-medium">v{versionInfo.version}</span>
            </>
          )}
          <div className="absolute right-0 flex items-center gap-1.5 text-gray-400">
            <span className="text-[11px]">Powered by</span>
            <img src="/valuechain-logo.png" alt="Valuechain" className="h-5 w-auto" />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
